export default {
    before: 'before',
    after: 'after',
};
